import { Component, inject, Input, signal } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";

import { Constants } from "../../../constants/constants";
import { PageMode } from "../../../constants/enums";
import { AuxGovDirection, ValidatorModelType } from "../../../models";
import { GovernmentDirectionsEditorService, ValidatorApiService } from "../../../services";
import { FormInputComponent } from "../../form";

@Component({
  selector: "adaa-aux-direction-modal",
  imports: [TranslatePipe, ReactiveFormsModule, FormInputComponent],
  templateUrl: "./aux-direction-modal.html",
  styleUrl: "./aux-direction-modal.scss",
})
export class AuxDirectionModalComponent {
  private readonly _translateService = inject(TranslateService);
  private readonly _toastrService = inject(ToastrService);
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _validatorApiService = inject(ValidatorApiService);

  modal: NgbActiveModal = inject(NgbActiveModal);
  directionsService = inject(GovernmentDirectionsEditorService);

  @Input() auxDirection: AuxGovDirection;
  @Input() pageMode: PageMode = PageMode.view;

  formValidation = signal<ValidatorModelType | undefined>(undefined);
  submitted: boolean = false;
  PageMode = PageMode;
  auxDirectionForm: FormGroup;

  public ngOnInit(): void {
    this._prepareForm();
    this.auxDirectionForm.patchValue(this.auxDirection);
  }

  public save(): void {
    this.submitted = true;
    if (!this.auxDirectionForm.valid) {
      this._toastrService.warning(this._translateService.instant("notification.warning.missing_info"));
      return;
    }

    this.auxDirection.nameAE = this.auxDirectionForm.get("nameAE")?.value;
    this.auxDirection.nameEN = this.auxDirectionForm.get("nameEN")?.value;
    this.auxDirection.dscAE = this.auxDirectionForm.get("dscAE")?.value;
    this.auxDirection.dscEN = this.auxDirectionForm.get("dscEN")?.value;

    this.modal.close(this.auxDirection);
  }

  private _prepareForm() {
    this.auxDirectionForm = this._formBuilder.group({
      id: null,
      govSubDirectionId: null,
      nameAE: null,
      nameEN: null,
      dscAE: null,
      dscEN: null,
    });

    this._validatorApiService
      .applyValidationToForm(Constants.VALIDATORS_CONF_KEY.VALIDATION_GOVERNMENT_AUX_DIRECTIONS, this.auxDirectionForm)
      .subscribe({
        next: (res) => {
          this.formValidation.set(res.validation);
          this.auxDirectionForm = res.form;
        },
      });
  }
}
